import { useEffect } from "react";
import { useApp } from "@/store/useApp";

export function CatalogBootstrap() {
  const account = useApp((state) => state.account);
  const bootstrapSessionData = useApp((state) => state.bootstrapSessionData);

  useEffect(() => {
    if (!account || account.role !== "CLIENT") return;
    void bootstrapSessionData();
  }, [account, bootstrapSessionData]);

  return null;
}
